"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectIsErr = exports.expectIsOk = exports.expectErrForResult = exports.expectOkForResult = void 0;
/**
 *  Return _input_ as `T` if the passed _input_ is `Ok(T)`.
 *  Otherwise, throw `TypeError` with the passed `msg`.
 */
function expectOkForResult(input, msg) {
    if (!input.ok) {
        throw new TypeError(msg);
    }
    return input.val;
}
exports.expectOkForResult = expectOkForResult;
/**
 *  Return _input_ as `E` if the passed _input_ is `Err(E)`.
 *  Otherwise, throw `TypeError` with the passed `msg`.
 */
function expectErrForResult(input, msg) {
    if (input.ok) {
        throw new TypeError(msg);
    }
    return input.err;
}
exports.expectErrForResult = expectErrForResult;
/**
 *  @deprecated
 *  Please use {@link expectOkForResult}
 */
exports.expectIsOk = expectOkForResult;
/**
 *  @deprecated
 *  Please use {@link expectErrForResult}
 */
exports.expectIsErr = expectErrForResult;
